import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatDialogModule} from '@angular/material/dialog';
import { WorkflowDiagramComponent } from './workflow-diagram.component';
import {IconsModule} from '../../icons/icons.module';
import {MatTabsModule} from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
  declarations: [WorkflowDiagramComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,
    MatDialogModule,
    IconsModule,
    MatTabsModule,
    MatProgressSpinnerModule
  ]
})
export class WorkflowDiagramModule { }
